/**
 * Fechas solo-día desde API (LocalDate / "YYYY-MM-DD" / ISO que empieza con fecha).
 * Evita usar `new Date("YYYY-MM-DD")` (UTC) que desplaza el día en zonas como AR.
 */
export function normalizeDateOnlyFromApi(
  value: string | null | undefined
): string {
  if (value == null || value === '') return '';
  const m = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : String(value).trim();
}

/** Mostrar fecha calendario en es-AR sin corrimiento por zona. */
export function formatDateOnlyLocal(
  dateString: string | null | undefined
): string {
  if (dateString == null || dateString === '') return '-';
  const normalized = normalizeDateOnlyFromApi(dateString);
  const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(normalized);
  if (parts) {
    const y = Number(parts[1]);
    const mo = Number(parts[2]) - 1;
    const d = Number(parts[3]);
    const local = new Date(y, mo, d);
    return local.toLocaleDateString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return String(dateString);
  }
}
